export const regularLimitLow = 4850.0;
export const regularLimitHigh = 4999.99;
export const sinkLimitLow = 14000.0;
export const sinkLimitHigh = 14999.99;
export const chinaLimitLow = 9500.0;
export const chinaLimitHigh = 9999.99;
